import { SupplierModel } from './../../models';

export class SupplierOrderFilterModel {

    constructor(
        public supplier: SupplierModel,
        public orderNo: string,
        public orderStatus: any,
        public orderContract: string) { }

    isSet(): Boolean {
        return (Boolean)(this.supplier
            || this.orderNo
            || this.orderContract
            || (this.orderStatus && this.orderStatus.label !== 'All'));
    }
}



// WEBPACK FOOTER //
// ./src/app/suppliers-barcodes/models/supplier-order-filter.model.ts